import Vue from 'vue'

const type = Vue.config.productionTip ? 'dev' : 'prod'

const configs = {
  prod: {
    API_IP: 'https://api.ncmhelper.com.br/progeta/',
    JWT_PASSWORD: 'chewbacca_from_progeta',
    name: 'Planos Assessoria'
  },
  dev: {
    API_IP: 'https://api.ncmhelper.com.br/progeta/',
    JWT_PASSWORD: 'chewbacca_from_progeta',
    name: 'Planos Assessoria'
  }
}

export default configs[type]



// WEBPACK FOOTER //
// ./src/configs.js